export default __webpack_public_path__ + "static/grid-types-light-790f4017767ac2562cc382c560237da3ba3805c416f8b02f1e6214701c22046d.png";